import axios from "axios";

import {
  LOCAL_STORAGE_401_OCCURRENCES_COUNT_KEY,
  LocalStorage,
} from "util/localStorage";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5004";

const instance = axios.create({
  baseURL: apiUrl,
  headers: {
    "App-Version": process.env.REACT_APP_SENTRY_RELEASE || "undefined",
  },
});

export const publicInstance = axios.create({
  baseURL: apiUrl,
  headers: {
    "App-Version": process.env.REACT_APP_SENTRY_RELEASE || "undefined",
  },
});

const websocketServerInstance = axios.create({
  baseURL: process.env.REACT_APP_SOCKET_URL || "http://localhost:5000",
  headers: {
    "App-Version": process.env.REACT_APP_SENTRY_RELEASE || "undefined",
  },
});

// Under the Playwright build (MOCK_AUTH0, see vite.config.ts + playwright/
// auth0Mock.tsx) the app is always "authenticated" against a mocked Auth0, so
// there is no real session to end. A 401 there only means a test left an
// endpoint unmocked; redirecting `window.location` to /logout would blank the
// whole app mid-test (and Playwright cannot reliably intercept every stray XHR
// before it reaches staging). Skip the redirect in that build only —
// `process.env.MOCK_AUTH0` is undefined in every production/preview bundle, so
// the real logout-on-401 behavior is unchanged there.
const redirectToLogoutOn401 = (error: {
  response?: { status?: number };
}): void => {
  if (process.env.MOCK_AUTH0) return;
  if (error?.response?.status !== 401) return;
  const occurrencesCount = LocalStorage.upsert401Occurrences();
  window.location.href = `/logout?${LOCAL_STORAGE_401_OCCURRENCES_COUNT_KEY}=${occurrencesCount}`;
};

websocketServerInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    redirectToLogoutOn401(error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  (response) => response,
  (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    redirectToLogoutOn401(error);
    // Do something with response error
    return Promise.reject(error);
  }
);

export { websocketServerInstance };

export default instance;
